import React from 'react';
import {
  ToggleRadioField,
  type ToggleRadioOption,
} from '~/components/forms/ToggleRadioField';

type DoYouHaveMonthlyObligationsFieldProps = {
  name: string;
  label?: string;
  description?: string;
};

const DoYouHaveMonthlyObligationsField: React.FC<
  DoYouHaveMonthlyObligationsFieldProps
> = ({ name, label, description }) => {
  const options: ToggleRadioOption<boolean>[] = [
    { value: true, label: 'Ja' },
    { value: false, label: 'Nee' },
  ];

  return (
    <ToggleRadioField
      name={name}
      label={label}
      description={description}
      options={options}
      gridClassName="grid grid-cols-2 gap-3 md:flex md:h-10 md:items-center"
      labelClassName="h-[44px] w-full md:w-auto"
    />
  );
};

export default DoYouHaveMonthlyObligationsField;
